import { render, staticRenderFns } from "./OverviewTopPosts.vue?vue&type=template&id=0d8b2c74&scoped=true&"
import script from "./OverviewTopPosts.vue?vue&type=script&lang=js&"
export * from "./OverviewTopPosts.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTopPosts.vue?vue&type=style&index=0&id=0d8b2c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b2c74",
  null
  
)

export default component.exports